import Button from '@material-ui/core/Button';
import { datadogRum } from '@datadog/browser-rum';
import { Link } from '@backstage/core-components';
import LinkIcon from '@mui/icons-material/Link';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Typography } from '@material-ui/core';
import { useStyles } from './CardWithGradientBackground.style';

interface CardWithGradientBackgroundProps {
  title: string;
  href: string;
  color: string;
  isExternal?: boolean;
}

function CardWithGradientBackground({
  title,
  href,
  color,
  isExternal,
}: Readonly<CardWithGradientBackgroundProps>) {
  const { cx, classes } = useStyles({ favoriteLinkColor: color });

  const handleClick = () => {
    datadogRum.addAction('favorite_links_widget_link_clicked', {
      href,
    });
  };

  return (
    <Button
      component={Link}
      to={href}
      startIcon={isExternal ? <OpenInNewIcon /> : <LinkIcon />}
      className={cx(classes.button)}
      onClick={handleClick}
      {...(isExternal
        ? { target: '_blank', rel: 'noopener noreferrer' }
        : { target: '_self' })}
    >
      <Typography className={classes.title}>{title}</Typography>
    </Button>
  );
}

export { CardWithGradientBackground };
